var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-payment-edit-pane"},[_c('external-confirmation-section',{attrs:{"title":_vm.$tc('MypagePage.common.externalConfirmation.title.web'),"message":_vm.$tc('MypagePage.common.externalConfirmation.message.web')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }